// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Uncaught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-screen">
          <div className="error-boundary-box">
            <h1>&#9888; SYSTEM FAILURE</h1>
            <p>A critical error occurred. Your save data is safe.</p>
            <pre>{this.state.error?.message}</pre>
            <button onClick={() => this.setState({ hasError: false, error: null })}>
              RESTART SYSTEMS
            </button>
            <button onClick={() => window.location.reload()}>
              FULL RELOAD
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
